import React, { memo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Slider from 'react-slick'

import MobileLayout from '../../../../components/MobileLayout'
import Button from '../../../../components/atoms/GoodFlipButton'
import ArrowIcon from '../../../../components/atoms/Arrow'
import ZydusHeader from '../../../../components/molecules/ZydusHeader'
import CancelIcon from '../../../../assets/icons/cancel_icon.svg'
import HomeBannerDollyImg from '../../../../assets/images/home_banner_dolly.webp'
import HomeBanner1 from '../../../../assets/images/homebanner1.webp'
import HomeBanner2 from '../../../../assets/images/homebanner2.webp'
import HomeBanner3 from '../../../../assets/images/homebanner3.webp'
import HomeBanner4 from '../../../../assets/images/homebanner4.webp'
import HomeBanner5 from '../../../../assets/images/homebanner5.webp'
import HomeBanner6 from '../../../../assets/images/homebanner6.webp'
import HomeBanner7 from '../../../../assets/images/homebanner7.webp'
import HomeBanner8 from '../../../../assets/images/homebanner8.webp'
import HomeBanner9 from '../../../../assets/images/homebanner9.webp'
import HomeBanner10 from '../../../../assets/images/homebanner10.webp'
import HomeBanner11 from '../../../../assets/images/homebanner11.webp'
import HomeBannerVikasKhannaImg1 from '../../../../assets/images/vikas_khanna_1.webp'
import HomeBannerVikasKhannaImg2 from '../../../../assets/images/vikas_khanna_2.webp'
import HomeBannerIMG1 from '../../../../assets/images/home_banner_1.webp'
import HomeBannerIMG2 from '../../../../assets/images/home_banner_2.webp'
import HomeBannerIMG3 from '../../../../assets/images/home_banner_3.webp'
import HomeBannerIMG4 from '../../../../assets/images/home_banner_4.webp'
import HomeBannerIMG5 from '../../../../assets/images/home_banner_5.webp'
import HomeBannerIMG6 from '../../../../assets/images/home_banner_6.webp'
import HomeBannerIMG7 from '../../../../assets/images/home_banner_7.webp'
import HomeBannerIMG8 from '../../../../assets/images/home_banner_8.webp'
import HomeBannerIMG9 from '../../../../assets/images/home_banner_9.webp'
import { Footer } from '../index'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Text from '../../../../components/atoms/Text'

const CKDAwarenessPage = () => {
  const navigate = useNavigate()
  const [activeSlide, setActiveSlide] = useState(0)
  const [youtubeVideoId, setYoutubeVideoId] = useState(null)

  const awarenessData = [
    {
      img: HomeBannerIMG9,
      imgDesktop: HomeBanner1,
      onClick: () => {
        handlePlay('E_-yVJsULZk')
      },
      showButton: true,
      buttonTitle: 'Watch Video',
    },
    {
      img: HomeBannerIMG8,
      imgDesktop: HomeBanner2,
      onClick: () => {
        handlePlay('9OoY53Ngduk')
      },
      showButton: true,
      buttonTitle: 'Watch Video',
    },
    {
      img: HomeBannerIMG7,
      imgDesktop: HomeBanner3,
      onClick: () => {
        handlePlay('BOXB01O1LmU')
      },
      showButton: true,
      buttonTitle: 'Watch Video',
    },
    {
      img: HomeBannerIMG6,
      imgDesktop: HomeBanner4,
      onClick: () => {
        handlePlay('bXLqMedwz_I')
      },
      showButton: true,
      buttonTitle: 'Watch Video',
    },
    {
      img: HomeBannerIMG5,
      imgDesktop: HomeBanner5,
      onClick: () => {
        handlePlay('trVDkUv5LpU')
      },
      showButton: true,
      buttonTitle: 'Watch Video',
    },
    {
      img: HomeBannerVikasKhannaImg1,
      imgDesktop: HomeBanner6,
      onClick: () => {
        handlePlay('MHSVDWZnXqQ')
      },
      showButton: true,
      buttonTitle: 'Watch Video',
    },
    {
      img: HomeBannerVikasKhannaImg2,
      imgDesktop: HomeBanner7,
      onClick: () => {
        handlePlay('qnYpXHOVYY0')
      },
      showButton: true,
      buttonTitle: 'Watch Video',
    },
    {
      img: HomeBannerDollyImg,
      imgDesktop: HomeBanner8,
      onClick: () => {
        handlePlay('fAun0a3zTlA')
      },
      showButton: true,
      buttonTitle: 'Watch Video',
    },
    {
      img: HomeBannerIMG1,
      imgDesktop: HomeBanner9,
      onClick: () => {},
    },
    {
      img: HomeBannerIMG2,
      imgDesktop: HomeBanner10,
      onClick: () => {},
    },
    {
      img: HomeBannerIMG3,
      imgDesktop: HomeBanner11,
      onClick: () => {},
    },
    {
      img: HomeBannerIMG4,
      onClick: () => {},
    },
  ]

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    arrows: false,
    beforeChange: (_oldIndex, newIndex) => setActiveSlide(newIndex),
    appendDots: (dots) => (
      <div style={{ textAlign: 'center', marginTop: '10px' }}>
        <ul
          className="dot-parent"
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '0px',
            padding: '0px',
          }}
        >
          {dots}
        </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: i === activeSlide ? '#000000' : '#C4C4C480',
          border: 'none',
          transition: 'background-color 0.3s ease',
          cursor: 'pointer',
          position: 'relative',
          top: '-35px',
        }}
      />
    ),
  }

  const handlePlay = (videoId) => {
    setYoutubeVideoId(videoId)
  }

  const handleClose = () => {
    setYoutubeVideoId(null)
  }

  const getYoutubeEmbedSrc = (videoId) => {
    if (!videoId) return null
    const params = new URLSearchParams({
      autoplay: '1',
      playsinline: '1',
      rel: '0',
      modestbranding: '1',
    })
    if (typeof window !== 'undefined' && window.location?.origin) {
      params.set('origin', window.location.origin)
    }
    return `https://www.youtube-nocookie.com/embed/${videoId}?${params.toString()}`
  }

  return (
    <MobileLayout>
      <div className="max-w-lg lg:max-w-5xl xl:max-w-5xl mx-auto">
        <ZydusHeader />
        <div className="p-4 pt-10 mt-12 lg:mt-20">
          <Text variant="display" size="large" tag="p">
            Awareness Films
          </Text>
          <Text variant="body" size="large" tag="p" className="mt-3 max-w-2xl">
            Short films that spread awareness, share real stories, and inspire
            action around Chronic Kidney Disease (CKD)
          </Text>
        </div>
        <div className="w-full mt-2 lg:mt-4">
          <Slider {...sliderSettings} className="w-full">
            {awarenessData.map((banner, index) => (
              <div
                key={index}
                className="flex flex-col"
                onClick={banner.onClick}
              >
                <div className="relative w-full lg:flex lg:justify-center">
                  {banner.imgDesktop ? (
                    <picture>
                      <source
                        media="(min-width: 1024px)"
                        srcSet={banner.imgDesktop}
                      />
                      <img
                        src={banner.img}
                        alt={`home_banner_${index}`}
                        className="h-auto w-full lg:max-h-full lg:w-auto lg:object-contain"
                      />
                    </picture>
                  ) : (
                    <img
                      src={banner.img}
                      alt={`home_banner_${index}`}
                      className="h-auto w-full lg:rounded-2xl lg:max-h-[520px] lg:w-auto lg:object-contain"
                    />
                  )}
                  {banner?.showButton && (
                    <Button
                      title={banner?.buttonTitle || 'Click Here'}
                      onClick={banner.onClick}
                      rightIcon={
                        <ArrowIcon direction="right" color="#199EA5" />
                      }
                      leftIcon={null}
                      className="!w-[78%] sm:!w-[70%] lg:!w-[340px] !absolute !bottom-4 lg:!bottom-6 !left-1/2 !-translate-x-1/2"
                    />
                  )}
                </div>
              </div>
            ))}
          </Slider>
        </div>
        <Footer />
      </div>

      {youtubeVideoId && (
        <div className="fixed inset-0 bg-black bg-opacity-80 z-[2000] flex items-center justify-center">
          <div
            className="absolute top-4 right-4 z-50 cursor-pointer bg-white p-0.5 border rounded-full"
            onClick={handleClose}
          >
            <img src={CancelIcon} />
          </div>
          <div className="relative w-full max-w-5xl aspect-video mx-4">
            <iframe
              className="absolute top-0 left-0 w-full h-full"
              src={getYoutubeEmbedSrc(youtubeVideoId)}
              title="youtube video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              referrerPolicy="origin-when-cross-origin"
            ></iframe>
          </div>
        </div>
      )}
    </MobileLayout>
  )
}

export default memo(CKDAwarenessPage)
